import React, { Fragment } from "react";
import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";
import { Lock } from "@material-ui/icons";

const SectionTitle = styled.div`
  font-size: 24px;
`;

const NewButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
    position: unset;
  }
  &&:hover {
    background: none;
  }
`;

const NewLockedButton = styled(Button)`
  && {
    margin-left: 4px;
    padding: 8px 8px 8px 2px;
    border-radius: 0;
    color: #888888;
    background: none;
    position: unset;
  }
  &&:hover {
    background: none;
  }
`;

const Container = styled.div`
  padding: 5px;
  margin-top: 10px;
  border-width: 0px;  
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
`;

const Header = props => {
  if (props.parent && !props.parent.isProTier()) {
    return (
      <Container>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
          <Grid item lg={10} md={9}>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
              <Grid item>
                <SectionTitle className="title-component">{props.title}</SectionTitle>
              </Grid>
              <>
                <Grid item hidden={!props.hasAction}>
                  <NewLockedButton id={props.buttonId} variant="contained" onClick={props.parent.openPopup} disableRipple>
                    <Lock />
                    {props.actionTitle}
                  </NewLockedButton>
                </Grid>
              </>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <Container>
      <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
        <Grid item lg={10} md={9}>
          <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
            <Grid item>
              <SectionTitle className="title-component">{props.title}</SectionTitle>
            </Grid>
            <>
              <Grid item hidden={!props.hasAction}>
                <NewButton id={props.buttonId} variant="contained" onClick={props.action} disableRipple>
                  {props.actionTitle}
                </NewButton>
              </Grid>
            </>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default (Header);
